import React from "react";
import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/colaboratoryHrData.json";

const columns = [
  { field: "colaboratore", headerName: "Colaboratore", width: 500 },
  { field: "ruolo", headerName: "Ruolo", width: 180 },
  { field: "livello", headerName: "Livello", width: 90 },
  { field: "trattamento", headerName: "Trattamento", width: 180 },
  { field: "stato", headerName: "Attivo", width: 120 },
  { field: "creatoil", headerName: "Inixio", width: 120 },
  { field: "fine", headerName: "Fine", width: 120 },
  { field: "utente", headerName: "Utente", width: 90 },
  { field: "azioni", headerName: "Azioni", width: 90 },
];

const ColaboratoryAnagrafiche = () => {
  return (
    <>
      <Header />
      <div className="pageTemplate">
        <Table data={tableData} columns={columns} navData={"colaboratory"} />
      </div>
    </>
  );
};

export default ColaboratoryAnagrafiche;
